module.exports = __webpack_public_path__ + "static/media/ddex.08777d56.svg";